module.exports = "./img/desktop_logo.827fe58.png";